















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Blocks
---------------------------------------- */

import CasesBlock from '@part/blocks/CasesBlock.vue';
import CollageBlock from '@part/blocks/CollageBlock.vue';
import ImageBlock from '@part/blocks/ImageBlock.vue';
import ParallaxBlock from '@part/blocks/ParallaxBlock.vue';
import QuoteBlock from '@part/blocks/QuoteBlock.vue';
import SectionBlock from '@part/blocks/SectionBlock.vue';
import TextBlock from '@part/blocks/TextBlock.vue';
import VideoBlock from '@part/blocks/VideoBlock.vue';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    components: {
        CasesBlock,
        CollageBlock,
        ImageBlock,
        ParallaxBlock,
        QuoteBlock,
        SectionBlock,
        TextBlock,
        VideoBlock
    },

    props: {
        blocks: Array,
        color: String,
        type: String
    },

    methods: {
        blockName: string => {
            if (typeof string !== 'string') return '';
            const name = string.charAt(0).toUpperCase() + string.slice(1);
            return name + 'Block'
        }
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Blocks extends Vue {}

